var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1764_4245)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.00003 3.93921C7.15742 3.93921 5.65833 5.43831 5.65833 7.28092C5.65833 9.12352 7.15742 10.6226 9.00003 10.6226C10.8426 10.6226 12.3417 9.12352 12.3417 7.28092C12.3417 5.43831 10.8427 3.93921 9.00003 3.93921ZM9.00003 9.2156C7.93325 9.2156 7.06535 8.3477 7.06535 7.28092C7.06535 6.21413 7.93325 5.34623 9.00003 5.34623C10.0668 5.34623 10.9347 6.21413 10.9347 7.28092C10.9347 8.3477 10.0668 9.2156 9.00003 9.2156Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.00002 0.0698242C5.02381 0.0698242 1.78894 3.30473 1.78894 7.2809V7.48023C1.78894 9.49117 2.94186 11.8345 5.21576 14.4451C6.86417 16.3377 8.48955 17.6573 8.55789 17.7126L9.00002 18.0698L9.44214 17.7126C9.51052 17.6573 11.1359 16.3377 12.7843 14.4452C15.0581 11.8345 16.2111 9.49121 16.2111 7.48027V7.28093C16.2111 3.30473 12.9762 0.0698242 9.00002 0.0698242ZM14.8041 7.48027C14.8041 10.8786 10.4253 14.9925 9.00002 16.2413C7.57433 14.9921 3.19596 10.8784 3.19596 7.48027V7.28093C3.19596 4.08059 5.79967 1.47688 9.00002 1.47688C12.2004 1.47688 14.8041 4.08059 14.8041 7.28093V7.48027Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1764_4245"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0 0.0698242)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.7a947ecfad3a1799ab60ebdde1bb124d.svg";
export { ForwardRef as ReactComponent };